/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Next_AriaInputs */



/**
* | output |
* | --- |
* | "Proceed to selected import flow" |
*
* @param {File_Import_Next_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_next_aria = /** @type {((inputs?: File_Import_Next_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Next_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proceed to selected import flow")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fahren Sie mit dem ausgewählten Importvorgang fort.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Procedi al flusso di importazione selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к выбранному процессу импорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proceder al flujo de importación seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("继续执行选定的导入流程")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したインポートフローに進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित आयात प्रवाह पर आगे बढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prossiga para o fluxo de importação selecionado.")
	return /** @type {LocalizedString} */ ("Proceed to selected import flow")
});